export default __webpack_public_path__ + "static/3-f687525541c57faaf3683a6f9bd75ef6.jpeg";